import fluxWmsStockApi from "@/api/FluxWmsStockApi";

const fluxWmsStockStore = {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    querySkuStock({ commit }, data) {
      return fluxWmsStockApi.querySkuStock(data);
    },
  },
};

export default fluxWmsStockStore;
